import React, { Fragment } from 'react';
import DeliveryPartnerSales from './DeliveryPartnerSales';

// Thin route entry — the V3 shell lives inside the view.
const DeliveryPartnerReport = () => (
    <Fragment>
        <DeliveryPartnerSales />
    </Fragment>
);

export default DeliveryPartnerReport;
